import Bloc from './Bloc.js';
import Types from './Types.js';

export default class ForEachStatus extends Bloc {

	constructor (src, ctx) {

		super("forstatus", src, ctx, true);
		this.f = (src, ins, props) => {
			var entity = ins[0], type = ins[1];
			var statuses = entity.statuses;
			statuses.filter(status => type === "" || type === status.model.type).forEach(status => {
				this.out = [status.model.key];
				if (this["for each"])
					this["for each"].execute(props);
			})
			this.out = null;
			if (this.completed)
				this.completed.execute(props);
			return;
		}
		this.types = [Types.entity, Types.statustype];
		this.toPrepare.push("for each");
		this.toPrepare.push("completed");
	}
}